import IndexConent from "../../../../src/pages/use-cases/page-content/archiving-and-retrieval/search-and-indexing.md";
import * as React from 'react';
export default {
  IndexConent,
  React
};